import './styles.css'
import Slideshow from './components/Slideshow'
import Profile from './components/Profile'
import Projects from './components/Projects'
import Footer from './components/Footer'
function App() {
  return (
    <main>
      <Slideshow />
      <Profile />
      <Projects />
      <Footer />
    </main>
  )
}

export default App
